// 超级管理员角色id
export const SUPER_ROLE_ID = '0ef89403f4d111eb9d7f0242ac110004'

// 用户信息key
export const USER_INFO_KEY = 'DAILY_LOG_USER_INFO'
